import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as actions from '../actions/micustomeractions'
import * as appUtility from '../../../infrastructure/apputilityfunctions'
import * as appConstants from './../../../overrides/appconstants'
import { useLocation } from 'react-router-dom';
import {
    Stepper,
    Step,
    StepLabel,
    Button,
    Box,
    Typography,
    TextField,
} from '@mui/material';


export default function CustomerInformation() {

    const { register: registerCustomerInformation, handleSubmit: handleSubmitCustomerInformation,
        reset: resetCustomerInformation, setValue, watch: watchInsuredInformation, formState: { errors: errorsCustomerInformation } } = useForm();
    const state = useSelector(state => state.miCustomerSharedReducer);
    const dispatch = useDispatch();
    let masters = state.masters;
    let customerInformation = state.customerInformation;
    let basicInfoNewEnq = state.basicInfoNewEnq;

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const enquiryId = queryParams.get("enquiryId");
    const encryptedEnquiryRefId1 = queryParams.get("encryptedEnquiryRefId1");
    const encryptedEnquiryRefId2 = queryParams.get("encryptedEnquiryRefId2");

    let isCustomerConfirmed = basicInfoNewEnq?.isCustomerConfirmed == true

    useEffect(() => {

        dispatch(actions.getMICustomerMasters()).then(() => {
            //if (enquiryId) 
            {
                dispatch(actions.getQuoteInformation({ encryptedEnquiryRefId1, encryptedEnquiryRefId2 })).then(() => {
                    dispatch(actions.getCustomerInformationById({ encryptedEnquiryRefId1, encryptedEnquiryRefId2 })).then(() => {
                        dispatch(actions.getMembersByQuoteId(enquiryId))
                            .then(() => {
                                // Once members are fetched, set the flag to true
                                // setIsMembersFetched(true);
                            })
                            .catch((error) => {
                                console.error('Error fetching members:', error);
                            });
                    })
                })
            }
            /* else {
                 dispatch(actions.getMembersByQuoteId(enquiryId))
                     .then(() => {
                         // Once members are fetched, set the flag to true
                         //setIsMembersFetched(true);
                     })
                     .catch((error) => {
                         console.error('Error fetching members:', error);
                     });
             }*/


        })



    }, []);

    useEffect(() => {
        //  if (customerInformation.customerId) {
        let valuesToMap = [
            { "insuredType": customerInformation.insuredType },
            { "emiratesId": customerInformation.emiratesId },
            { "mobile": customerInformation.mobile },
            { "salutation": customerInformation.salutation },
            { "firstName": customerInformation.firstName },
            { "middleName": customerInformation.middleName },
            { "lastName": customerInformation.lastName },
            { "maritalSatus": customerInformation.maritalSatus },
            { "dateofBirth": customerInformation.dateofBirth },
            { "nationality": customerInformation.nationality },
            { "email": customerInformation.email },
            { "companyCRNumber": customerInformation.companyCRNumber },
            { "fullName": customerInformation.fullName },
            { "tradeLicenseNo": customerInformation.tradeLicenseNo },
            { "tradeLicenseExpiryDate": customerInformation.tradeLicenseExpiryDate },
            { "policyEmail": customerInformation.policyEmail },
            { "entityType": customerInformation.entityType },
            { "entityId": customerInformation.entityId },
            { "companyMobile": customerInformation.companyMobile },
            { "salaryBandTypeId": customerInformation.salaryBandTypeId },
            { "poBox": customerInformation.poBox },
            { "address": customerInformation.address },
            { "gender": customerInformation.gender },

        ];
        valuesToMap.forEach(i => Object.keys(i).forEach(key => setValue(key, i[key])));
    }, [customerInformation]);


    const handleCustomerInformationChange = (e) => {
        let { name, value } = e.target;

        if (name == 'emiratesId') {

            if (e.target.value.length === 3 && !customerInformation.emiratesId.match(/.*-$/)) {
                value = value += "-"
            }
            if (e.target.value.length === 8 && !customerInformation.emiratesId.match(/.*-$/)) {
                value = value += "-"
            }
            if (e.target.value.length === 16 && !customerInformation.emiratesId.match(/.*-$/)) {
                value = value += "-"

            }
            value = value.substr(0, 18);
        }
        if (name == "companyMobile") {
            if (e.target.value.length === 2 && !customerInformation.companyMobile.match(/.*-$/)) {
                value = value += "-"
            }
            value = value.substr(0, 10);
        }
        if (name == "mobile") {
            if (e.target.value.length === 3 && !customerInformation.mobile.match(/.*-$/)) {
                value = value += "-"
            }
            value = value.substr(0, 11);
        }
        if (name === "dateofBirth" && !(value == null || value == "")) {

        }
        dispatch(actions.updateCustomerInformationParams({ name, value }));

    }
    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }
    const checkAgeLimit = (val) => {
        if (customerInformation.dateofBirth == null || customerInformation.dateofBirth == '') {
            return false;
        }
        let today = new Date()
        let date1 = today.getDate() + '-' + parseInt(today.getMonth() + 1) + '-' + today.getFullYear()

        try {
            const dt_date1 = new Date(val);
            const dt_date2 = new Date(today);
            const date1_time_stamp = dt_date1.getTime();
            const date2_time_stamp = dt_date2.getTime();
            let calc;
            if (date1_time_stamp > date2_time_stamp) {
                calc = new Date(date1_time_stamp - date2_time_stamp);
            } else {
                calc = new Date(date2_time_stamp - date1_time_stamp);
            }
            const calcFormatTmp = calc.getDate() + '-' + (calc.getMonth() + 1) + '-' + calc.getFullYear();
            const calcFormat = calcFormatTmp.split("-");
            const years_passed = Number(Math.abs(calcFormat[2]) - 1970);
            let result = false;
            if (years_passed >= 18) {
                result = true;
            }
            return result;
        }
        catch (error) {
            return false;
        }
    }
    const compareEmiratesIdYear = (val) => {
        try {

            var dateofBirth = new Date(customerInformation.dateofBirth);
            var year = dateofBirth.getFullYear();
            var blankYear = '1111';
            const getYearFromEmiratesID = s => s.includes('-') && s.substr(s.indexOf('-') + 1).split('-')[0];
            if (year == getYearFromEmiratesID(val) || getYearFromEmiratesID(val) == blankYear) {
                return true;
            }
            return false;
            //}
        } catch (error) {
            return false;
        }
    }


    const onSubmitCustomerInformation = () => {

        dispatch(actions.customerInsuredInformationSave(/* enquiryId,  */encryptedEnquiryRefId1, encryptedEnquiryRefId2));
        // .then(resp => {
        //     if (resp) {
        //         document.getElementById('CloseCustomerInforamtionModal').click();
        //         dispatch(onResetInsuredInformation());

        //     }
        // });

    }
    let isInsuredTypeIndividual = customerInformation.insuredType == appConstants.INSURED_TYPE_INDIVIDUAL;
    const handleInsuredinPolicyChange = (e) => {
        let { id, checked } = e.target;
        let name = "customerInPolicyYN";

        let value = checked ? "Y" : "N";
        dispatch(actions.updateCustomerInformationParams({ name, value }));
    }

    const onErrorCustomerInformation = (errorsInsuredInformation, e) => {

        console.log(errorsInsuredInformation, e)
    }
    const onResetInsuredInformation = (e) => {
        // resetCustomerInformation();
        // dispatch(actions.clearCustomerInformationParams());
    }


    let EntityIdTitle = customerInformation?.entityType == appConstants.ENTITY_TYPE_DOMAIN_ID_CITIZEN ? "UID Number" : customerInformation?.entityType == appConstants.ENTITY_TYPE_DOMAIN_ID_ESTABLISHMENT ? "Establishment Code" : (customerInformation?.entityType == appConstants.ENTITY_TYPE_DOMAIN_ID_PROPERTY_OWNER || customerInformation?.entityType == appConstants.ENTITY_TYPE_DOMAIN_ID_RESIDENT) ? "Visa File Number" : "Sponsor ID"

    function renderIndividualPolicy() {

        let SalaryBand =
            <select className={errorsCustomerInformation.salaryBandTypeId ? 'form-select is-invalid' : 'form-select'} data-toggle="select2" id="salaryBandTypeId"
                {...registerCustomerInformation("salaryBandTypeId", { required: true, onChange: (e) => handleCustomerInformationChange(e) })}
                //value={memberInformation.salaryBand}
                disabled={/*customerInformation.customerInPolicyYN == 'Y' */ /* false */isCustomerConfirmed}
            >
                <option value=''>--Salary Band--</option>
                {masters?.salaryBandMasters?.map((salary, index) => (
                    <option value={salary.domainValue} key={index}>
                        {salary.domainValueName}

                    </option>
                ))}
            </select>

        let maritalSatus =
            <select className={errorsCustomerInformation.maritalSatus ? 'form-select is-invalid' : 'form-select'} data-toggle="select2" id="maritalSatus" name="maritalSatus" tabIndex={9}
                {...registerCustomerInformation("maritalSatus", {
                    required: true,
                    onChange: (e) => handleCustomerInformationChange(e)
                })}
                disabled={customerInformation.customerInPolicyYN == 'Y' || isCustomerConfirmed}
            >
                <option value=''>Select </option>

                {masters.maritalStatusMasters.map((maritalSatusMasters, index) => (
                    <option value={maritalSatusMasters.id} key={index}>
                        {maritalSatusMasters.name}
                    </option>
                ))}

            </select>
        let Salutation =
            <select className={errorsCustomerInformation.salutation ? 'form-select is-invalid' : 'form-select'} data-toggle="select2" id="salutation" name="salutation" tabIndex={5}
                disabled={isCustomerConfirmed}
                {...registerCustomerInformation("salutation", {
                    required: true,
                    onChange: (e) => handleCustomerInformationChange(e)
                })} >
                <option value=''>Select</option>

                {masters.salutationMasters.map((SalutationMasters, index) => (
                    <option value={SalutationMasters.domainValue} key={index}>
                        {SalutationMasters.domainValueName}
                    </option>
                ))}

            </select>
        let Nationality =
            <select className={errorsCustomerInformation.nationality ? 'form-select is-invalid' : 'form-select'} data-toggle="select2" id="nationality" name="nationality" tabIndex={10}
                disabled={customerInformation.customerInPolicyYN == 'Y' || isCustomerConfirmed}
                {...registerCustomerInformation("nationality", {
                    required: true,
                    onChange: (e) => handleCustomerInformationChange(e)
                })} >
                <option value=''>Select </option>

                {masters?.nationalityMaster?.map((NationalityMasters, index) => (

                    <option value={NationalityMasters.domainValue} key={index}>
                        {NationalityMasters.domainValueName}
                    </option>
                ))}

            </select>
        let EmiratesID = <input className={errorsCustomerInformation.emiratesId ? 'form-control is-invalid' : 'form-control'}
            placeholder="XXX-XXXX-XXXXXXX-X"
            id="emiratesId"
            disabled={/* customerInformation.customerInPolicyYN == 'Y' *//* false */isCustomerConfirmed}
            name="emiratesId" tabIndex={3}
            {...registerCustomerInformation("emiratesId", {
                required: true,
                validate: {
                    yearscheck: (v) => compareEmiratesIdYear(v)
                },
                pattern: { value: /(^[7][8][4][-][0-9]{4}[-][0-9]{7}[-][0-9]{1}$)|(^[1][1][1][-][1]{4}[-][1]{7}[-][1]{1}$)/, message: "Format: XXX-XXXX-XXXXXXX-X" },
                onChange: (e) => handleCustomerInformationChange(e),


            })}
        />

        let DateofBirth = <input className={errorsCustomerInformation.dateofBirth ? 'form-control is-invalid' : 'form-control'}
            type="date" id="dateofBirth" required=""
            placeholder="Enter Date of Birth"
            name='dateofBirth' tabIndex={2}
            disabled={customerInformation.customerInPolicyYN == 'Y' || isCustomerConfirmed}
            {...registerCustomerInformation("dateofBirth", {
                required: true,

                onChange: (e) => handleCustomerInformationChange(e),
                validate: {
                    agecheck: (value) => checkAgeLimit(value)

                },
            })}
        />
        let FirstName = <input className={errorsCustomerInformation.firstName ? 'form-control is-invalid' : 'form-control'}
            id="firstname" required="" tabIndex={6}
            placeholder="Enter First name"
            name='firstName'
            disabled={isCustomerConfirmed}
            //  value={customerInformation.firstName}
            {...registerCustomerInformation("firstName", {
                required: true,
                onChange: (e) => handleCustomerInformationChange(e)
            })}
        />
        let MiddleName = <input className={errorsCustomerInformation.middleName ? 'form-control is-invalid' : 'form-control'}
            type="text" id="middleName" required="" tabIndex={7}
            placeholder="Enter Middle name"
            name='middleName'
            disabled={isCustomerConfirmed}
            //  value={customerInformation.middleName}
            {...registerCustomerInformation("middleName", {

                onChange: (e) => handleCustomerInformationChange(e)
            })}
        />
        let LastName = <input className={errorsCustomerInformation.lastName ? 'form-control is-invalid' : 'form-control'}
            type="text" id="lastName" required="" tabIndex={8}
            placeholder="Enter Last Name"
            name='lastName'
            disabled={isCustomerConfirmed}
            //  value={customerInformation.lastName}
            {...registerCustomerInformation("lastName", {
                required: true,
                onChange: (e) => handleCustomerInformationChange(e)
            })}
        />

        // let checbox = <div className="form-check" id="Check1">
        //     <input type="checkbox" id={customerInformation.gender} className="form-check-input" name="combobox"
        //         onChange={value => handleInsuredinPolicyChange(value)} checked={customerInformation.customerInPolicyYN == "Y" ? true : false}
        //     //value={customerInformation.customerInPolicyYN} 

        //     />
        // </div>
        let EntityId = <input className={errorsCustomerInformation.entityId ? 'form-control is-invalid' : 'form-control'}
            id="fullNaentityIdme" required=""
            placeholder={`Enter ${EntityIdTitle}`}
            name='entityId' tabIndex="12"
            value={customerInformation.entityId}
            disabled={isCustomerConfirmed}
            {...registerCustomerInformation("entityId", {
                required: true,
                onChange: (e) => handleCustomerInformationChange(e)
            })}
        />
        let EntityType =
            <select className={errorsCustomerInformation.entityType ? 'form-select is-invalid' : 'form-select'} data-toggle="entityType" id="entityType" name="entityType"
                disabled={isCustomerConfirmed}
                {...registerCustomerInformation("entityType", {
                    required: true,
                    onChange: (e) => handleCustomerInformationChange(e)
                })} value={customerInformation.entityType} tabIndex={13}>
                <option value=''>--Entity--</option>
                {masters.entityTypeMasters.map((policyMasters, index) => (
                    <option value={policyMasters.domainValue} key={index}>
                        {policyMasters.domainValueName}
                    </option>
                ))}
            </select>

        /* let Gender = <div className="row g-2" id="gender" name="gender"
         >
             <div class="mb-2 col-md-3">
                 <label for="inputPassword4" className="form-label">Gender<span className="redstar">* </span></label>
             </div>
             <div class="form-check mb-2 col-md-3">
                 <input type="radio" id="customRadio1" name="gender" value={appConstants.GENDER_MALE} checked={customerInformation.gender == appConstants.GENDER_MALE ? true : false} tabIndex={8} {...registerCustomerInformation("gender", { required: true, onChange: (e) => handleCustomerInformationChange(e) })} class="form-check-input" />
                 <label class="form-check-label " for="customRadio1">Male</label>
             </div>
             <div class="form-check mb-2 col-md-3">
                 <input type="radio" id="customRadio2 " name="gender" value={appConstants.GENDER_FEMALE} checked={customerInformation.gender == appConstants.GENDER_FEMALE ? true : false} {...registerCustomerInformation("gender", { required: true, onChange: (e) => handleCustomerInformationChange(e) })} class="form-check-input" />
                 <label class="form-check-label" for="customRadio2">Female</label>
             </div>
         </div >*/
        let Gender = <select className={errorsCustomerInformation.gender ? 'form-select is-invalid' : 'form-select'}
            data-toggle="select2" id="memberGender" name="memberGender"
            {...registerCustomerInformation("gender", {
                required: true,
                onChange: (e) => handleCustomerInformationChange(e)
            })}

            disabled={customerInformation.customerInPolicyYN == 'Y' || isCustomerConfirmed}

        >
            <option value=''>Select </option>
            {masters?.genderMasters?.map((gender, index) => (
                <option value={gender.id} key={index}>
                    {gender.name}
                </option>
            ))}
        </select>
        let Address1 = <input className={errorsCustomerInformation.address ? 'form-control is-invalid' : 'form-control'}
            type="text" id="address" required=""
            placeholder="Enter Address"
            name='address'
            disabled={isCustomerConfirmed}
            //  value={insuredInforamtion.lastName}
            {...registerCustomerInformation("address", {
                required: true,
                onChange: (e) => handleCustomerInformationChange(e)
            })}
        />
        let PoBox = <input className={errorsCustomerInformation.poBox ? 'form-control is-invalid' : 'form-control'}
            type="text" id="poBox" required=""
            placeholder="Enter P.O. Box"
            name='poBox'
            disabled={isCustomerConfirmed}
            //  value={insuredInforamtion.lastName}
            {...registerCustomerInformation("poBox", {
                required: true,
                onChange: (e) => handleCustomerInformationChange(e)
            })}
        />


        return (
            <>
                <div className="row g-2">
                    <div className="mb-3 col-md-3">
                        <div className="input-group">
                            <div className="col-md-4">
                                <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Salutation</label>
                                {Salutation}
                            </div> <div className="col-md-8">
                                <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> First Name</label>
                                {FirstName}
                            </div></div></div>
                    <div className="mb-3 col-md-3">
                        <label for="inputState" className="form-label"> Middle Name</label>
                        {MiddleName}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Last Name</label>
                        {LastName}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Emirates ID</label>

                        {EmiratesID}
                        {errorsCustomerInformation.emiratesId?.message && <span>{errorsCustomerInformation.emiratesId?.message}</span>}<br></br>
                        {errorsCustomerInformation.emiratesId?.type === "yearscheck" && <span className='redstar'>Date of Birth Year and Emirates Id Year not Valid</span>}
                    </div>

                </div>
                <div className="row g-2">
                    {/* <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"> <span className='redstar'>*</span> Insured Type </label>
                        {InsuredType}
                    </div> */}
                    <div className="mb-3 col-md-3">
                        <label for="inputState" className="form-label"><span className='redstar'>*</span> Date of Birth</label>
                        {DateofBirth}
                        {errorsCustomerInformation.dateofBirth?.type === "agecheck" && <span className='redstar'>You are not 18 years Old</span>}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label for="inputState" className="form-label"><span className='redstar'>*</span> Nationality</label>
                        {Nationality}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label">Gender</label>
                        {Gender}
                        {errorsCustomerInformation.gender && <span className="redstar"> Select Gender </span>}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Marital Status</label>
                        {maritalSatus}
                    </div>


                </div>

                <div className="row g-2">

                    <div className="mb-3 col-md-3">
                        <label for="inputState" className="form-label"><span className='redstar'>*</span> Salary Band</label>
                        {SalaryBand}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"> <span className='redstar'>*</span> Sponsor Type</label>
                        {EntityType}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> {EntityIdTitle} </label>
                        {EntityId}
                    </div>


                </div>
                <div className="row g-2">
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"> <span className='redstar'>*</span> Address</label>
                        {Address1}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> P.O. Box </label>
                        {PoBox}
                    </div>
                </div>

            </>
        )
    }
    function renderCompanyPolicy() {
        let EntityType =
            <select className={errorsCustomerInformation.entityType ? 'form-select is-invalid' : 'form-select'} data-toggle="entityType" id="entityType" name="entityType"
                {...registerCustomerInformation("entityType", {
                    required: true,
                    onChange: (e) => handleCustomerInformationChange(e)
                })} value={customerInformation.entityType} tabIndex={10}>
                <option value=''>--Entity--</option>
                {masters.entityTypeMasters.map((policyMasters, index) => (
                    <option value={policyMasters.domainValue} key={index}>
                        {policyMasters.domainValueName}
                    </option>
                ))}
            </select>

        let CompanyCRNumber = <input className={errorsCustomerInformation.companyCRNumber ? 'form-control is-invalid' : 'form-control'}
            id="companyCRNumber"
            placeholder="Enter Company CR Number"
            name='companyCRNumber' tabIndex="2"

            value={customerInformation.companyCRNumber}
            {...registerCustomerInformation("companyCRNumber", {
                required: true,

                onChange: (e) => handleCustomerInformationChange(e)
            })}
        />
        let FullName = <input className={errorsCustomerInformation.fullName ? 'form-control is-invalid' : 'form-control'}
            id="fullName" required=""
            placeholder="Enter Full Name"
            name='fullName' tabIndex="4"
            value={customerInformation.fullName}
            {...registerCustomerInformation("fullName", {
                required: true,
                onChange: (e) => handleCustomerInformationChange(e)
            })}
        />
        let TradeLicenseNumber = <input className={errorsCustomerInformation.tradeLicenseNo ? 'form-control is-invalid' : 'form-control'}
            id="tradeLicenseNo" required=""
            placeholder="Enter Trade License No" tabIndex="6"
            name='tradeLicenseNo'
            value={customerInformation.tradeLicenseNo}
            {...registerCustomerInformation("tradeLicenseNo", {
                required: true,
                onChange: (e) => handleCustomerInformationChange(e)
            })}
        />

        let EntityId = <input className={errorsCustomerInformation.entityId ? 'form-control is-invalid' : 'form-control'}
            id="fullNaentityIdme" required=""
            placeholder={`Enter ${EntityIdTitle}`}
            name='entityId' tabIndex="9"
            value={customerInformation.entityId}
            {...registerCustomerInformation("entityId", {
                required: true,
                onChange: (e) => handleCustomerInformationChange(e)
            })}
        />

        let TradeLicenseExpiryDate = <input className={errorsCustomerInformation.tradeLicenseExpiryDate ? 'form-control is-invalid' : 'form-control'}
            type="date" id="tradeLicenseExpiryDate" required=""
            placeholder="Enter Trade License Expiry Date"
            name='tradeLicenseExpiryDate' tabIndex="7"
            value={customerInformation.tradeLicenseExpiryDate}
            {...registerCustomerInformation("tradeLicenseExpiryDate", {
                required: true,
                min: { value: Date(), message: "This Date should be greater than Today's Date" },
                onChange: (e) => handleCustomerInformationChange(e)
            })}
        />

        return (
            <>
                <div className="row g-2">
                    {/* <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"> <span className='redstar'>*</span> Insured Type </label>
                        {InsuredType}
                    </div> */}
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Company CR Number </label>
                        {CompanyCRNumber}
                    </div>

                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"><span className="redstar">*</span> Full Name</label>
                        {FullName}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"><span className='redstar'>*</span>  Trade License Number </label>
                        {TradeLicenseNumber}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> Trade License Expiry Date </label>
                        {TradeLicenseExpiryDate}
                        {errorsCustomerInformation.tradeLicenseExpiryDate?.message && <span>{errorsCustomerInformation.tradeLicenseExpiryDate?.message}</span>}

                    </div>



                </div>
                <div className="row g-2">

                </div>
                <div className="row g-2">
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"> <span className='redstar'>*</span> Entity Type</label>
                        {EntityType}
                    </div>
                    <div className="mb-3 col-md-3">
                        <label for="inputPassword4" className="form-label"><span className='redstar'>*</span> {EntityIdTitle} </label>
                        {EntityId}
                    </div>
                </div>
            </>
        )
    }
    return (
        <>
            <form onSubmit={handleSubmitCustomerInformation(onSubmitCustomerInformation, onErrorCustomerInformation)}>

                {!isInsuredTypeIndividual &&
                    <div>
                        {renderCompanyPolicy()}
                    </div>
                }
                {isInsuredTypeIndividual &&
                    <div>
                        {renderIndividualPolicy()}
                    </div>
                }

                {!isCustomerConfirmed && <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>

                    <Button variant="contained" color="success" type="submit" disabled={isCustomerConfirmed}> Save </Button>
                </Box>}
            </form>




        </>

    )
}